import styled from '@emotion/styled';
import {
  Autocomplete,
  Box,
  Button,
  IconButton,
  TextField,
} from '@mui/material';

export const StockTakeToolbar = props => {
  const { searchedZones, selectedZone, setSelectedZone } = props;

  return (
    <Box>
      <HeaderWrapper>
        <div
          style={{
            width: '100%',
            flexDirection: 'row',
            display: 'flex',
            gap: '18px',
            justifyContent: 'flex-start',
          }}
        >
          <div style={{ width: '320px' }}>
            <Autocomplete
              options={searchedZones || []}
              autoHighlight
              value={selectedZone || null}
              getOptionLabel={option => option.value}
              noOptionsText={
                <div className="w-full flex justify-center">موردی یافت نشد</div>
              }
              renderOption={(args, option) => (
                <div {...args} dir="rtl">
                  {option.value}
                </div>
              )}
              onChange={(event, newValue) => {
                setSelectedZone(prev => newValue);
              }}
              sx={{
                '.MuiInputBase-root': {
                  paddingRight: '9px !important',
                },
              }}
              renderInput={params => (
                <TextField
                  {...params}
                  sx={{
                    '.MuiAutocomplete-endAdornment': {
                      right: 'unset !important',
                      left: '9px',
                    },
                    '.MuiAutocomplete-endAdornment button': {
                      mr: 0.5,
                    },
                  }}
                  label="انتخاب انبار"
                  inputProps={{
                    ...params.inputProps,
                    autoComplete: 'zone', // disable autocomplete and autofill
                  }}
                  className="gray-icon"
                  InputProps={{
                    ...params.InputProps,
                  }}
                />
              )}
            />
          </div>
          <div>
            <AddBtn
              sx={{ width: '140px' }}
              variant="contained"
              onClick={() =>
                props.submitCartex({
                  zoneGuid: selectedZone?.key,
                })
              }
            >
              {props.addLable}
            </AddBtn>
          </div>
        </div>
        <form />
      </HeaderWrapper>
    </Box>
  );
};

const Container = styled(Box)`
  ${({ theme }) => ({
    p: 2,
    pb: 0,
    justifyContent: 'space-between',
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
  })}
`;

const HeaderWrapper = styled.div`
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  gap: 10px;
  margin: 1.5rem 0 1rem 0;

  @media all and (max-width: 600px) {
    flex-direction: column-reverse;
    align-items: flex-start;
    margin-top: 15px;
    padding-right: 10px;
  }
`;

const AddBtn = styled(Button)`
  margin-left: 10px;
  background-color: #27348b;
`;
